import { Box, Text } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { Field as FormikField, FieldAttributes, useFormikContext } from 'formik';
import { JSX, ReactNode } from 'react';

export default function Field({
  children,
  ...props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: Readonly<FieldAttributes<any> & { children?: ReactNode | JSX.Element }>) {
  const { errors, touched } = useFormikContext();

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const error = touched[props.name as keyof typeof touched] && errors[props.name as keyof typeof errors];

  return (
    <Tooltip content={<Text textStyle="screenStd">{error as string}</Text>} disabled={!error}>
      <Box display="flex" width="100%">
        <FormikField {...props}>{children}</FormikField>
      </Box>
    </Tooltip>
  );
}
